import { render, staticRenderFns } from "./CardManager.vue?vue&type=template&id=2daa21ab&scoped=true&"
import script from "./CardManager.vue?vue&type=script&lang=js&"
export * from "./CardManager.vue?vue&type=script&lang=js&"
import style0 from "./CardManager.vue?vue&type=style&index=0&id=2daa21ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa21ab",
  null
  
)

component.options.__file = "CardManager.vue"
export default component.exports